export const AUTOSCORING_DISABLED_PROFILES = ['machine learning'];
